import { benefitsPopupId } from './config';
import styles from './benefitsPopup.module.css';

const useBenefitsPopup = () => {
  const toggle = () =>
    document
      .getElementById(benefitsPopupId)
      ?.classList.toggle(styles['benefitsPopupContainer--active']);
  return toggle;
};

export default useBenefitsPopup;
